import { Col, Row, Toast, ToastContainer } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import SectionTitle from '../../sitel/demon/ui/atoms/sectionTitle';
import ReligiousOrMedicalTab from './religiousOrMedicalTab';
import AllRequestsTable from './allRequestsTable';
import './index.css';
import { useState } from 'react';
import { useEffect } from 'react';

export default function Landing() {
  const [searchParams] = useSearchParams();
  const flag = searchParams.get('flag');

  const [show, setShow] = useState(true);

  useEffect(() => {
    setShow(flag && (flag === 'submitSuccess' || flag === 'updateSubmitSuccess') ? true : false);
  }, [flag]);

  return (
    <>
      <SectionTitle>Submit a new request</SectionTitle>

      <Row className='bg-body rounded shadow-sm mb-5'>
        <Col className='p-4'>
          <ReligiousOrMedicalTab />
        </Col>
      </Row>

      <SectionTitle>Request History</SectionTitle>

      <Row className='bg-body shadow-sm'>
        <Col className='p-0'>
          <AllRequestsTable />
        </Col>
      </Row>

      <ToastContainer position='top-end' className='p-4'>
        <Toast onClose={() => setShow(false)} bg='light' show={show} delay={10000} autohide>
          <Toast.Header>
            <i className='fas fa-bullhorn fs-5 me-2 text-info'></i>
            <strong className='me-auto'>Success</strong>
            <small>just now</small>
          </Toast.Header>
          <Toast.Body>
            { flag === 'submitSuccess' && (<>Request for exemption submitted. <br /></>) }
            { flag === 'updateSubmitSuccess' && (<>Request for exemption updated. <br /></>) }
            You can view in the list below.
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}
